export default __webpack_public_path__ + "static/media/digital_account_right.780363fc.png";